import { FaClockRotateLeft, FaPersonSkiing, FaSnowflake } from 'react-icons/fa6';
import { formatSkiReportValue } from '../utils/skiReports.utils';

/**
 * Defines the three cards inside each resort's accordion.
 * Each detail tells the shared WeatherCard which label and report value to show.
 * Units match the existing Ski Reports display; values with unknown units stay as supplied.
 */
export const skiReportSections = [
  {
    id: 'snowConditions',
    title: 'Snow Conditions',
    Icon: FaSnowflake,
    emptyMessage: 'No snow conditions available.',
    details: [
      {
        id: 'newSnowMinimum',
        label: 'New snow minimum (24 hours)',
        getValue: (report) => formatSkiReportValue(report.new_snow_min24),
      },
      {
        id: 'newSnowMaximum',
        label: 'New snow maximum (24 hours)',
        getValue: (report) => formatSkiReportValue(report.new_snow_max24),
      },
      {
        id: 'primarySurface',
        label: 'Primary surface',
        getValue: (report) => formatSkiReportValue(report.primary_surface),
      },
      {
        id: 'baseDepthMinimum',
        label: 'Base depth minimum',
        getValue: (report) => formatSkiReportValue(report.base_depth_min),
      },
      {
        id: 'baseDepthMaximum',
        label: 'Base depth maximum',
        getValue: (report) => formatSkiReportValue(report.base_depth_max),
      },
      {
        id: 'snowmaking',
        label: 'Snowmaking',
        getValue: (report) => formatSkiReportValue(report.snow_making),
      },
    ],
  },
  {
    id: 'snowHistory',
    title: 'Snow History',
    Icon: FaClockRotateLeft,
    emptyMessage: 'No snow history available.',
    details: [
      {
        id: 'seasonalSnowfall',
        label: 'Seasonal snowfall',
        getValue: (report) => formatSkiReportValue(report.seasonal_snowfall, ' in.'),
      },
      {
        id: 'lastSnowfallDate',
        label: 'Last snowfall date',
        getValue: (report) => formatSkiReportValue(report.last_snowfall_date),
      },
      {
        id: 'lastSnowfallAmount',
        label: 'Last snowfall amount',
        getValue: (report) => formatSkiReportValue(report.last_snowfall_amount, ' in.'),
      },
      {
        id: 'previousSnowfallDate',
        label: 'Previous snowfall date',
        getValue: (report) => formatSkiReportValue(report.previous_snowfall_date),
      },
      {
        id: 'previousSnowfallAmount',
        label: 'Previous snowfall amount',
        getValue: (report) => formatSkiReportValue(report.previous_snowfall_amount, ' in.'),
      },
    ],
  },
  {
    id: 'operations',
    title: 'Operations',
    Icon: FaPersonSkiing,
    emptyMessage: 'No operations information available.',
    details: [
      {
        id: 'operationHours',
        label: 'Operating hours',
        getValue: (report) => formatSkiReportValue(report.operation_hours),
      },
      {
        id: 'operationStatus',
        label: 'Operating status',
        getValue: (report) => formatSkiReportValue(report.operation_status),
      },
      {
        id: 'resortStatus',
        label: 'Resort status',
        getValue: (report) => formatSkiReportValue(report.resort_status),
      },
      {
        id: 'projectedOperations',
        label: 'Projected operations',
        getValue: (report) => formatSkiReportValue(report.projected_operations),
      },
      {
        id: 'snowComments',
        label: 'Snow comments',
        getValue: (report) => formatSkiReportValue(report.snow_comments24),
      },
      {
        id: 'generalComments',
        label: 'General comments',
        getValue: (report) => formatSkiReportValue(report.general_comments),
      },
      {
        id: 'nightSkiing',
        label: 'Night skiing',
        getValue: (report) => formatSkiReportValue(report.night_skiing),
      },
      {
        id: 'liftsOpen',
        label: 'Lifts open',
        getValue: (report) => formatSkiReportValue(report.num_lift_open),
      },
      {
        id: 'trailsOpen',
        label: 'Trails open',
        getValue: (report) => formatSkiReportValue(report.num_trails_open),
      },
      {
        id: 'milesOpen',
        label: 'Miles open',
        getValue: (report) => formatSkiReportValue(report.num_miles_open),
      },
      {
        id: 'acresOpen',
        label: 'Acres open',
        getValue: (report) => formatSkiReportValue(report.num_acres_open),
      },
      {
        id: 'runsOpen',
        label: 'Runs open',
        getValue: (report) => formatSkiReportValue(report.percent_runs_open, '%'),
      },
      {
        id: 'crossCountry',
        label: 'Cross-country skiing',
        getValue: (report) => formatSkiReportValue(report.cross_country),
      },
      {
        id: 'snowboarding',
        label: 'Snowboarding',
        getValue: (report) => formatSkiReportValue(report.snow_boarding),
      },
      {
        id: 'totalLifts',
        label: 'Total lifts',
        getValue: (report) => formatSkiReportValue(report.total_lifts),
      },
      {
        id: 'totalTrails',
        label: 'Total trails',
        getValue: (report) => formatSkiReportValue(report.total_trails),
      },
    ],
  },
];
